import { exists } from '@/api'

export interface NewArrivalNoticeMagazine {
  id: number
  displayTitle: string
}

export function NewArrivalNoticeMagazineFromJSON(
  json: any
): NewArrivalNoticeMagazine {
  return {
    id: json.id,
    displayTitle: exists(json, 'display_title') ? json.display_title : ''
  }
}
